export default __webpack_public_path__ + "static/gaming@2x-3a285e5e6336dae51d634a3d4cd38a05.png";